import { GetStaticPaths } from 'next'
import { Durations } from '@/constants/durations'
import { slugs } from '@/constants/slugs'
import { DefaultLayout } from '@/layouts/DefaultLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { CustomExclusiveSceneView } from '@/views/ExclusiveSceneView/CustomExclusiveSceneView'

export const TruthAndTreasonExclusiveScenePage: NextPageWithLayout = () => {
  const { t } = useTranslate('the-shift-exclusive')

  return (
    <CustomExclusiveSceneView
      videoUrl="https://api.angelstudios.com/streaming/29083b3e-a1db-4418-8042-79bbe833ff74/master.m3u8?ttl=15552000&ts=1757105419&v=5&s=LgzagklUU5awxwOPKenYZHPCUjpXNIfYYLXAQYNZY69sQMFU49leOcFhoDqjah2tOkwrGmlvsRT%2BEgTeuEQARQ%3D%3D"
      imageUrl="https://images.angelstudios.com/image/upload/v1757102045/angel-studios/projects/truth-and-treason/Truth-_-Treason-_series_---Thumbnail-16x9.png"
      canonical="https://www.angel.com/m/truth-and-treason-series-exclusive-scene"
      title={t('truthAndTreasonExclusiveScene', 'Truth and Treason Exclusive Scene')}
      description={t(
        'truthAndTreasonExclusiveSceneDescription',
        'Watch this never before seen exclusive scene from Truth and Treason!',
      )}
      logoUrl="https://images.angelstudios.com/image/upload/v1736376480/studio-app/catalog/65ea2b1b-beca-4f2e-84a4-65e96bd97756.webp"
      projectSlug={slugs.truthAndTreasonSeries}
    />
  )
}

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [{ params: { locale: 'en' } }],
    fallback: 'blocking',
  }
}

export const getStaticProps = getStaticPropsErrorHandler(
  { filePath: 'pages/[locale]/m/truth-and-treason-series-exclusive-scene/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        ...(await loadTranslations(locale, [
          'common',
          'the-shift-exclusive',
          'guild',
          'join-the-guild',
          'guild-benefits',
        ])),
      },
      revalidate: Durations.ONE_DAY_IN_SECONDS,
    }
  },
)

TruthAndTreasonExclusiveScenePage.getLayout = (page) => {
  return (
    <DefaultLayout isDarkMode hideNavigation>
      {page}
    </DefaultLayout>
  )
}

export default TruthAndTreasonExclusiveScenePage
